<template>
  <div id="homePage">
    <template v-if="showContent">
      <Cover></Cover>
      <LastestNews :news="news"></LastestNews>
      <HomeContent :data="history"></HomeContent>
      <HomeContent :data="story"></HomeContent>
      <Contact :data="contact"></Contact>
    </template>
  </div>
</template>

<script>
import Cover from './Cover.vue'
import LastestNews from './LastestNews.vue'
import HomeContent from './Content.vue'
import Contact from './Contact.vue'

export default {
  components: {
    Cover,
    LastestNews,
    HomeContent,
    Contact
  },
  data () {
    return {
      news: {},
      history: {},
      story: {},
      contact: {},
      showContent: false
    }
  },
  created () {
    this.init()
  },
  methods: {
    init: async function () {
      if (this.$route.params.lang === 'en') {
        var history = await import('../../json/en/home/history.json')
        var story = await import('../../json/en/home/story.json')
        var contact = await import('../../json/en/home/contact.json')
        var news = await import('../../json/en/home/news.json')
      } else {
        history = await import('../../json/th/home/history.json')
        story = await import('../../json/th/home/story.json')
        contact = await import('../../json/th/home/contact.json')
        news = await import('../../json/th/home/news.json')
      }

      this.news = news
      this.history = history
      this.story = story
      this.contact = contact
      this.showContent = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/HOME/Index.vue